/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, Input, Output, EventEmitter, OnDestroy, ChangeDetectorRef } from '@angular/core';
import {
  SchemaField,
  Document,
  EnumerationFormat,
  DocumentSchema,
  SystemFieldType
  /* EnumerationValue*/
} from 'src/app/modules/core/store/models/document.model';
import { DocumentReader } from 'src/app/modules/core/store/models/document-reader';
import { DynamicField } from '../dynamic-field';
import { ViewComponent } from '../../../store/models/workflow.model';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { EnumerationService } from '../../../services/enumeration/enumeration.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-enumeration-field',
    templateUrl: './enumeration-field.component.html',
    styleUrls: ['./enumeration-field.component.scss'],
    standalone: false
})
export class EnumerationFieldComponent implements DynamicField, OnDestroy {
  EnumerationFormat = EnumerationFormat;
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  reader: DocumentReader;
  @Input() viewComponent: ViewComponent;
  isReadOnly: boolean;
  @Input() schema: DocumentSchema;
  @Input() dataset: Dataset;

  showFieldAsEdit: boolean = false;
  selectedValue: string = '---';
  dropdownValue: string;
  enumerationValues: any[] = [];
  private _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  ngOnInit(): void {
    this.enumerationValues = this.field?.enumerationValues;
    this.changeDetector.markForCheck();
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = this._isEdit && !this.isReadOnly;
  }

  get value(): any {
    return this._value;
  }

  set value(val: any) {
    if (!!!val) {
      val = [];
    }

    this.enumerationValues = this.field?.enumerationValues;
    let displayVal = '';
    for (const num of val) {
      const enumValue = this.enumerationValues?.find(p => p.value === num);
      if (!!enumValue) {
        displayVal += `${enumValue.name}, `;
      }
    }
    if (displayVal.length > 0) {
      displayVal = displayVal.slice(0, -2);
    }

    this.selectedValue = displayVal || '---';

    this.dropdownValue = val.length ? val[0].toString() : null;

    this._value = val;
  }
  private _value: number[] = [];

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  tpOnContentUpdated(): void {
    const fieldValue = this.reader.getFieldValue(this.field.systemName) || [];
    this.value = [...fieldValue];

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
    }
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }

  checkChange(checked: boolean, value: any): void {
    const valueInt = parseInt(value);
    if (!isNaN(valueInt)) {
      if (this.field?.settings?.format !== EnumerationFormat.MuiltiSelect) {
        this.value = [];
      }

      if (!checked) {
        if (!this.value.includes(value)) {
          this.value.push(valueInt);
        }
        return;
      } else {
        const idx = this.value.findIndex(v => v === valueInt);
        if (idx >= 0) {
          this.value.splice(idx, 1);
        }
      }
      this.onValueChanged();
    }
  }

  dropdownSelected(): void {
    const valueInt = parseInt(this.dropdownValue);

    if (!isNaN(valueInt)) {
      this.value = [];
      this.value.push(valueInt);
      this.onValueChanged();
    }
  }
}
